import { getSpacing } from 'ui/theme'

export const TEXT_BACKGROUND_OPACITY = 0.67

export const HEADER_BLACK_BACKGROUND_HEIGHT = getSpacing(24)
